const LOGGED_USER = '';

export default LOGGED_USER;

export const DEFAULT_NAMESPACE_USER_ID = 'abcde298-1b7a-5a37-b8d7-db8da1bab532';
